import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, X, Share2, ShoppingBag, CheckCircle } from 'lucide-react';
interface EnergyPopupProps {
  onClose: () => void;
  onOpenBoutique: () => void;
}
export function EnergyPopup({
  onClose,
  onOpenBoutique
}: EnergyPopupProps) {
  const handleShare = async () => {
    const shareData = {
      title: 'AuraSync',
      text: 'Dołącz do AuraSync i zadbaj o swój dobrostan.',
      url: 'https://aurasync.app'
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback to clipboard
        await navigator.clipboard.writeText(shareData.url);
        alert('Link skopiowany do schowka!');
      }
    } catch (err) {
      console.log('Error sharing:', err);
    }
  };
  const handleOpenBoutique = () => {
    onClose();
    onOpenBoutique();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-582">
      <motion.div className="absolute inset-0 bg-black/40 backdrop-blur-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={onClose} data-id="element-583" />
      <motion.div className="clean-panel rounded-3xl p-6 max-w-sm w-full mx-4 relative z-10 flex flex-col items-center text-center max-h-[90vh] overflow-y-auto" initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} data-id="element-584">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors" aria-label="Zamknij" data-id="element-585">
          <X className="w-5 h-5" data-id="element-586" />
        </button>

        <div className="w-12 h-12 rounded-full bg-yellow-50 flex items-center justify-center mb-4 border border-yellow-100 shrink-0" data-id="element-587">
          <Sparkles className="w-6 h-6 text-yellow-500" fill="currentColor" data-id="element-588" />
        </div>

        <h3 className="text-xl font-semibold text-zen-text mb-2" data-id="element-589">
          Punkty Energii
        </h3>
        <p className="text-sm text-slate-500 mb-6" data-id="element-590">
          Punkty Energii to Twoja wewnętrzna waluta dobrostanu. Zbieraj je i
          wymieniaj na premium funkcje.
        </p>

        <div className="w-full text-left space-y-4 mb-6" data-id="element-591">
          {/* Daily Bonus Section */}
          <div className="bg-green-50 border border-green-200 rounded-2xl p-4 flex flex-col items-center text-center" data-id="element-592">
            <p className="text-xs text-slate-600 mb-2" data-id="element-593">
              Otwierając aplikację codziennie otrzymasz 10 pkt energii
            </p>
            <div className="flex items-center space-x-2 text-green-600 font-medium text-sm mb-1" data-id="element-594">
              <CheckCircle className="w-4 h-4" data-id="element-595" />
              <span data-id="element-596">Dziś punkty przyznano</span>
            </div>
            <p className="text-[10px] text-zen-accent italic mt-1" data-id="element-597">
              Koniecznie zajrzyj tu jutro!
            </p>
          </div>

          {/* Referral Section */}
          <div className="bg-slate-50 rounded-2xl p-4 border border-slate-100" data-id="element-598">
            <div className="flex justify-between items-center mb-3" data-id="element-599">
              <span className="text-sm font-medium text-slate-700" data-id="element-600">
                Poleć aplikację znajomej
              </span>
              <span className="font-bold text-yellow-600 flex items-center text-sm bg-yellow-100 px-2 py-0.5 rounded-full" data-id="element-601">
                +50 <Sparkles className="w-3 h-3 ml-1" fill="currentColor" data-id="element-602" />
              </span>
            </div>
            <button onClick={handleShare} className="w-full clean-panel hover:bg-slate-50 rounded-xl py-2 text-xs font-medium text-slate-600 transition-colors flex items-center justify-center" data-id="element-603">
              <Share2 className="w-3.5 h-3.5 mr-2" data-id="element-604" />
              Udostępnij link
            </button>
          </div>

          {/* Boutique Section */}
          <div className="bg-slate-50 rounded-2xl p-4 border border-slate-100" data-id="element-605">
            <div className="flex justify-between items-center mb-3" data-id="element-606">
              <span className="text-sm font-medium text-slate-700" data-id="element-607">
                Zakup z Butiku
              </span>
              <span className="font-bold text-yellow-600 flex items-center text-sm bg-yellow-100 px-2 py-0.5 rounded-full" data-id="element-608">
                +500-1200{' '}
                <Sparkles className="w-3 h-3 ml-1" fill="currentColor" data-id="element-609" />
              </span>
            </div>
            <button onClick={handleOpenBoutique} className="w-full clean-panel hover:bg-slate-50 rounded-xl py-2 text-xs font-medium text-slate-600 transition-colors flex items-center justify-center" data-id="element-610">
              <ShoppingBag className="w-3.5 h-3.5 mr-2" data-id="element-611" />
              Otwórz Butik
            </button>
          </div>
        </div>

        <button onClick={onClose} className="w-full bg-zen-accent hover:bg-zen-accent/90 text-white rounded-full py-3 text-sm font-medium transition-colors mt-auto" data-id="element-612">
          Zamknij
        </button>
      </motion.div>
    </div>;
}